'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var timeWrapper = require('./time-wrapper-f3ea17c2.js');
var timePickerInput_styles = require('./time-picker-input.styles-2c771083.js');

var TimePickerInput = function (_a) {
    var is12h = _a.is12h, value = _a.value, onChange = _a.onChange, valueHeight = _a.valueHeight, maxVisible = _a.maxVisible, min = _a.min, max = _a.max, minuteStep = _a.minuteStep, timezone = _a.timezone, _b = _a.timePickerVariant, timePickerVariant = _b === void 0 ? 'default' : _b, variant = _a.variant, wrapperProps = tslib_es6.__rest(_a, ["is12h", "value", "onChange", "valueHeight", "maxVisible", "min", "max", "minuteStep", "timezone", "timePickerVariant", "variant"]);
    var pickerValue = value !== null && value !== void 0 ? value : new Date()
        .toLocaleTimeString(undefined, {
        // hour12 is false so it will be 24 hours in order to be modified for TimePicker component.
        timeZone: timezone, hour: '2-digit', minute: '2-digit', hour12: false,
    });
    return (React__default.createElement(timeWrapper.TimePickerWrapper, tslib_es6.__assign({ value: value, variant: variant, is12h: is12h }, wrapperProps),
        React__default.createElement(timePickerInput_styles.TimePickerStyled, { is12h: is12h, value: pickerValue, timePickerVariant: timePickerVariant, onChange: onChange, valueHeight: valueHeight, maxVisible: maxVisible, min: min, max: max, minuteStep: minuteStep })));
};

exports.TimePickerInput = TimePickerInput;
